import { render, staticRenderFns } from "./current-popup.vue?vue&type=template&id=39209a52&scoped=true&"
import script from "./current-popup.vue?vue&type=script&lang=js&"
export * from "./current-popup.vue?vue&type=script&lang=js&"
import style0 from "./current-popup.vue?vue&type=style&index=0&id=39209a52&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39209a52",
  null
  
)

export default component.exports